import { environment } from '../../environments/environment.prod';

export function addCookiesInfo() {
  const cognitoIdService: string = environment.cognitoIdentityService;
  const googleUser = window.localStorage.getItem(
    `${cognitoIdService}.LastAuthUser`
  );
  const cookieValue = getCookies('_pat');

  if (googleUser && cookieValue.length === 0) {
    const objectexample = {
      accessToken: getValueStorage('accessToken'),
      refreshToken: getValueStorage('refreshToken'),
      idToken: getValueStorage('idToken'),
    };

    document.cookie = `_pat=${objectexample.accessToken}`;
    document.cookie = `_prt=${objectexample.refreshToken}`;
    document.cookie = `_pit=${objectexample.idToken}`;
    document.cookie = `_pla=${googleUser}`;
  }
  if (cookieValue.length > 0 && !googleUser) {
    const accessT = getCookies('_pat');
    const refreshT = getCookies('_prt');
    const idT = getCookies('_pit');
    const lastU = getCookies('_pla');
    setValueStorage('accessToken', lastU, accessT);
    setValueStorage('refreshToken', lastU, refreshT);
    setValueStorage('idToken', lastU, idT);
    window.localStorage.setItem(`${cognitoIdService}.LastAuthUser`, lastU);
  }

  function getValueStorage(value: string): string {
    return (
      window.localStorage.getItem(
        `${cognitoIdService}.${googleUser}.${value}`
      ) || ''
    );
  }
  function setValueStorage(
    key: string,
    userGoogle: string,
    value: string
  ): void {
    window.localStorage.setItem(
      `${cognitoIdService}.${userGoogle}.${key}`,
      value
    );
  }
}

function getCookies(cookieName: string) {
  let lista = document.cookie.split(';');
  let micookie: any;
  for (const i in lista) {
    let busca = lista[i].search(cookieName);
    if (busca > -1) {
      micookie = lista[i];
    }
  }

  if (!micookie) {
    return '';
  }
  let igual = micookie.indexOf('=');
  let valor = micookie.substring(igual + 1);
  return valor;
}

export function resetCookies() {
  const cognitoIdService: string = environment.cognitoIdentityService;
  const googleUser = window.localStorage.getItem(
    `${cognitoIdService}.LastAuthUser`
  );
  document.cookie = `_pat=`;
  document.cookie = `_prt=`;
  document.cookie = `_pit=`;
  document.cookie = `_pla=`;
  localStorage.removeItem(getKeyStorage('accessToken'));
  localStorage.removeItem(getKeyStorage('refreshToken'));
  localStorage.removeItem(getKeyStorage('idToken'));
  localStorage.removeItem(`${cognitoIdService}.LastAuthUser`);
  localStorage.removeItem(getKeyStorage('userData'));
  localStorage.removeItem(getKeyStorage('clockDrift'));
  window.location.href = window.location.origin + '/login';

  function getKeyStorage(value: string): string {
    return `${cognitoIdService}.${googleUser}.${value}`;
  }
}
